export { default } from './IconChevronUp';
